import request from "@/utils/request";

//获取所有ip
function getIpList() {
    return request.get('/cms/section/ac_our_ip')
}
//获取所有ip名称
function getIpNameList() {
    return request.get('/cms/section/GetMenu/ac_our_ip')
}
//获取banner轮播
function getBanner() {
    return request.get('/cms/content/ac_ip_banner')
}
//获取新闻列表
function getNewsList() {
    return request.get('/cms/section/ac_ip_news_list')
}
//获取SNS列表
function getSnsList() {
    return request.get('/cms/section/ac_ip_sns')
}
export default {
    getIpList,
    getIpNameList,
    getBanner,
    getNewsList,
    getSnsList
}